import React, { Fragment } from "react";
import { RemoveCircle } from "@mui/icons-material";
import { Grid, IconButton, Tooltip } from "@mui/material";

import { TextField } from "../../../../components";

const TextFieldNumber = React.memo(
  ({ state, message, field, index, editState, dispatch }) => {
    const handleFieldChange = (value, name, key, index, num) => {
      dispatch({
        type: "UPDATE_NUMBER_FIELD",
        payload: { value, name, key, index, num },
      });
    };

    return (
      <Fragment>
        <Grid item xs={2}>
          <TextField
            size="small"
            value={state?.[field.field_name]?.org_trust}
            type="number"
            label={"Organisational Trust"}
            disabled={!editState}
            error={!!message.org_trust[index]}
            helperText={
              !!message.org_trust[index] && "It should be in between 0 & 5"
            }
            name={field.field_name}
            onChange={(e) =>
              handleFieldChange(
                e.target.value,
                field.field_name,
                "org_trust",
                index,
                5
              )
            }
          />
        </Grid>

        <Grid item xs={2}>
          <TextField
            size="small"
            type="number"
            value={state?.[field.field_name]?.sms_cpm}
            label={"SMS CPM"}
            disabled={!editState}
            error={!!message.sms_cpm[index]}
            helperText={
              !!message.sms_cpm[index] && "It should be in between 0 & 1000"
            }
            name={field.field_name}
            onChange={(e) =>
              handleFieldChange(
                e.target.value,
                field.field_name,
                "sms_cpm",
                index,
                1000
              )
            }
          />
        </Grid>

        <Grid item xs={2}>
          <TextField
            size="small"
            type="number"
            value={state?.[field.field_name]?.whatsapp_cpm}
            label={"whatsapp CPM"}
            disabled={!editState}
            error={!!message.whatsapp_cpm[index]}
            helperText={
              !!message.whatsapp_cpm[index] &&
              "It should be in between 0 & 1000"
            }
            name={field.field_name}
            onChange={(e) =>
              handleFieldChange(
                e.target.value,
                field.field_name,
                "whatsapp_cpm",
                index,
                1000
              )
            }
          />
        </Grid>

        <Grid item xs={2}>
          <TextField
            size="small"
            type="number"
            value={state?.[field.field_name]?.meta_cpm}
            label={"Meta CPM"}
            disabled={!editState}
            error={!!message.meta_cpm[index]}
            helperText={
              !!message.meta_cpm[index] && "It should be in between 0 & 1000"
            }
            name={field.field_name}
            onChange={(e) =>
              handleFieldChange(
                e.target.value,
                field.field_name,
                "meta_cpm",
                index,
                1000
              )
            }
          />
        </Grid>

        <Grid item xs={2}>
          <TextField
            size="small"
            type="number"
            value={state?.[field.field_name]?.google_cpm}
            label={"Google CPM"}
            disabled={!editState}
            error={!!message.google_cpm[index]}
            helperText={
              !!message.google_cpm[index] && "It should be in between 0 & 1000"
            }
            name={field.field_name}
            onChange={(e) =>
              handleFieldChange(
                e.target.value,
                field.field_name,
                "google_cpm",
                index,
                1000
              )
            }
          />
        </Grid>

        {editState && (
          <Grid item xs={1}>
            <Tooltip title="Clear Values">
              <IconButton
                onClick={() => {
                  dispatch({
                    type: "CLEAR_VALUES",
                    payload: { name: field.field_name },
                  });
                }}
              >
                <RemoveCircle />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        <Grid item xs={12} />
      </Fragment>
    );
  }
);

export default TextFieldNumber;
